export default __webpack_public_path__ + "static/media/IQ.e513b613.svg";